"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _color = _interopRequireDefault(require("./color"));
var _font = _interopRequireDefault(require("./font"));
var borderRadius = '8px';
var primaryColor = _color.default.primary;
var dayBorder = "solid 1px ".concat(_color.default.cloud);
var daySelectedBorderRadius = '0';
var calendarBgColor = '#fff';
var caretBorderColor = '#fff';
var dayColor = _color.default.gunMetal;
var captionColor = _color.default.charcoal;
var daySelected = "\n  border-radius: 0;\n  margin-top: 0;\n  float: inherit;\n";
var dayFont = "\n  font: ".concat(_font.default.secondaryRegular, ";\n  font-size: 10px;\n");
var selectedDayCopy = "\n  line-height: initial;\n  margin-top: 0;\n";
var datepicker = {
  borderRadius: borderRadius,
  primaryColor: primaryColor,
  dayBorder: dayBorder,
  daySelectedBorderRadius: daySelectedBorderRadius,
  calendarBgColor: calendarBgColor,
  caretBorderColor: caretBorderColor,
  dayColor: dayColor,
  daySelected: daySelected,
  dayFont: dayFont,
  captionColor: captionColor,
  selectedDayCopy: selectedDayCopy
};
var _default = exports.default = datepicker;